var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"infos"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"info",on:{"click":function($event){return _vm.detail(item)}}},[_c('el-image',{staticClass:"img",attrs:{"src":item.picture_link_list[0],"fit":"cover"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.product_name))])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55672f44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Goods.vue
// module id = null
// module chunks = 